import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-list-data-lang',
  templateUrl: './list-data-lang.component.html',
  styleUrls: ['./list-data-lang.component.css']
})
export class ListDataLangComponent implements OnInit {
    listDataKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.listDataKeyno = this.stateService.getStateParams()['listdata_keyno'];
    }

    private async loadLanguages() {
        if (!!this.listDataKeyno) {
            this.inputListLanguages = await this.datatask.Post(2721, { listdata_keyno: this.listDataKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2722, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    listdata_keyno: string;
    listdatalang_name: string;
    listdatalang_description: string;
    language_id: string;
    language_name: string;
    orderby: number;
}
